import lazyLoading from './lazyLoading'

export default {
  name: 'Online Monitor',
  system: 'online_monitor',
  path: '/onlineMonitor',
  meta: {
    auth: true,
    icon: 'fa-heartbeat',
    link: 'termsFilter/index.vue',
    label: 'Online Monitor'
  },
  component: lazyLoading('onlineMonitor', true)
}
